(function () {
  var TEST = false; /* true yapılırsa yalnızca ?lwlapp=test ile açılan tarayıcıda görünür */
  var root = document.getElementById('lwl-ai');
  if (!root) return;

  var KEY = 'lwlApp', DAY = 864e5;
  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function set(o) { try { var s = get(); for (var k in o) s[k] = o[k]; localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  var testOn = false;
  try {
    if (/[?&]lwlapp=test\b/.test(location.search)) localStorage.setItem('lwlAppTest', '1');
    if (/[?&]lwlapp=off\b/.test(location.search)) localStorage.removeItem('lwlAppTest');
    if (/[?&]lwlapp=reset\b/.test(location.search)) { localStorage.removeItem(KEY); localStorage.setItem('lwlAppTest', '1'); ['lwlAppCard', 'lwlAppPv', 'lwlAppGlow'].forEach(function (k) { sessionStorage.removeItem(k); }); }
    testOn = localStorage.getItem('lwlAppTest') === '1';
  } catch (e) {}

  var deferred = window.__lwlBip || null;
  window.addEventListener('beforeinstallprompt', function (e) { e.preventDefault(); deferred = e; });
  window.addEventListener('appinstalled', function () {
    deferred = null; set({ installed: Date.now() }); hideAll(); toast('LWL ana ekranına eklendi');
  });

  var mm = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var standalone = mm('(display-mode: standalone)') || mm('(display-mode: fullscreen)') || mm('(display-mode: minimal-ui)') || navigator.standalone === true;
  if (standalone) { set({ installed: Date.now() }); return; }
  if (TEST && !testOn) return;

  var ua = navigator.userAgent || '';
  var isIOS = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var isIPad = /iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var isAndroid = /Android/i.test(ua);
  var inApp = /Instagram|FBAN|FBAV|FB_IAB|FBIOS|Line\/|musical_ly|Bytedance|TikTok|Snapchat|Pinterest|LinkedInApp|GSA\//i.test(ua);
  var mobile = (isIOS || isAndroid || mm('(pointer: coarse)')) && Math.min(screen.width, screen.height) <= 1024;
  if (!mobile) return;

  var s0 = get();
  if (s0.installed && Date.now() - s0.installed < 120 * DAY) return;

  /* ---------- simgeler ---------- */
  function svg(p, extra) { return '<svg class="lwl-ai-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"' + (extra || '') + '>' + p + '</svg>'; }
  var IC = {
    phone: svg('<rect x="6.5" y="2.5" width="11" height="19" rx="2.6"/><path d="M12 7v6.5M9.4 11l2.6 2.6 2.6-2.6M10.5 18.5h3"/>'),
    share: svg('<path d="M12 3.5v11M8 7.5l4-4 4 4"/><path d="M8.5 10.5H6.5a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-7a1.5 1.5 0 0 0-1.5-1.5h-2"/>'),
    plus: svg('<rect x="4" y="4" width="16" height="16" rx="3.5"/><path d="M12 8.5v7M8.5 12h7"/>'),
    more: '<svg class="lwl-ai-svg" viewBox="0 0 24 24" aria-hidden="true"><circle cx="5.5" cy="12" r="1.8" fill="currentColor"/><circle cx="12" cy="12" r="1.8" fill="currentColor"/><circle cx="18.5" cy="12" r="1.8" fill="currentColor"/></svg>',
    kebab: '<svg class="lwl-ai-svg" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="5.5" r="1.8" fill="currentColor"/><circle cx="12" cy="12" r="1.8" fill="currentColor"/><circle cx="12" cy="18.5" r="1.8" fill="currentColor"/></svg>',
    menu: svg('<path d="M4.5 7h15M4.5 12h15M4.5 17h15"/>')
  };
  function k(icon, ios) { return '<span class="lwl-ai-k' + (ios ? ' lwl-ai-k--ios' : '') + '">' + IC[icon] + '</span>'; }

  /* ---------- giriş noktaları ---------- */
  var tpl = root.getAttribute('data-tpl'), dir = root.getAttribute('data-dir'), sfx = root.getAttribute('data-sfx');
  var isAtolye = sfx === 'kombin-atolyesi';

  function addFooterButton() {
    var copy = document.querySelector('.lwl-ft .lwl-ft__copy');
    if (!copy || document.querySelector('.lwl-ai-ft')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'lwl-ai-ft'; b.setAttribute('data-lwl-install', 'footer');
    b.innerHTML = IC.phone + '<span>LWL\'yi telefonuna ekle</span>';
    copy.parentNode.insertBefore(b, copy);
  }
  function addAtolyeButton() {
    if (!isAtolye) return;
    var help = document.querySelector('.lwl-ka .ka-help');
    if (!help || document.querySelector('.lwl-ai-pill')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'lwl-ai-pill'; b.setAttribute('data-lwl-install', 'atolye'); b.setAttribute('aria-label', 'LWL\'yi ana ekranına ekle');
    b.innerHTML = '<span class="lwl-ai-pill__i">' + IC.phone + '</span><span class="lwl-ai-pill__tip" aria-hidden="true">Ana ekranına ekle</span>';
    help.parentNode.insertBefore(b, help);
    var tourDone = false; try { tourDone = !!localStorage.getItem('lwlKaTour1'); } catch (e) {}
    if (tourDone && !ss('lwlAppGlow')) {
      ss('lwlAppGlow', '1');
      setTimeout(function () { b.classList.add('is-tip'); setTimeout(function () { b.classList.remove('is-tip'); }, 4500); }, 2500);
    }
  }

  /* ---------- alt kart (nazik hatırlatma) ---------- */
  var card = root.querySelector('.lwl-ai-card');
  var cardTimer = null;
  function cardAllowed() {
    if (isAtolye) return false;
    if (['cart', 'product', 'password', 'gift_card', '404', 'search', 'checkout'].indexOf(tpl) > -1 || dir === 'customers') return false;
    var s = get(), now = Date.now();
    if (s.installed && now - s.installed < 120 * DAY) return false;
    if ((s.dn || 0) >= 3 || (s.sc || 0) >= 5) return false;
    if (s.dismissed && now - s.dismissed < 14 * DAY) return false;
    if (s.guided && now - s.guided < 30 * DAY) return false;
    if (ss('lwlAppCard')) return false;
    return true;
  }
  function busy() {
    if (document.querySelector('.lwl-fab.is-docked')) return true;
    if (root.querySelector('.lwl-ai-sheet:not([hidden])')) return true;
    var b = getComputedStyle(document.body).overflow, h = getComputedStyle(document.documentElement).overflow;
    return b === 'hidden' || h === 'hidden';
  }
  function showCard() {
    if (!cardAllowed()) return;
    if (busy()) { setTimeout(showCard, 4000); return; }
    ss('lwlAppCard', '1');
    set({ sc: (get().sc || 0) + 1 });
    card.hidden = false;
    requestAnimationFrame(function () {
      document.body.style.setProperty('--lwl-ai-h', (card.offsetHeight + 16) + 'px');
      document.body.classList.add('lwl-ai-lift');
      card.classList.add('is-in');
    });
    cardTimer = setTimeout(function () { hideCard(); }, 15000);
    watchBusy();
  }
  function hideCard() {
    clearTimeout(cardTimer);
    if (!card || card.hidden) return;
    card.classList.remove('is-in');
    document.body.classList.remove('lwl-ai-lift');
    setTimeout(function () { card.hidden = true; }, 450);
  }
  function watchBusy() {
    var iv = setInterval(function () {
      if (card.hidden) { clearInterval(iv); return; }
      if (busy()) { clearInterval(iv); hideCard(); }
    }, 700);
  }
  card.querySelector('[data-lwl-ai-x]').addEventListener('click', function () {
    var s = get(); set({ dismissed: Date.now(), dn: (s.dn || 0) + 1 }); hideCard();
  });
  card.addEventListener('pointerdown', function () { clearTimeout(cardTimer); });

  function scheduleCard() {
    if (!cardAllowed()) return;
    var pv = (parseInt(ss('lwlAppPv'), 10) || 0) + 1; ss('lwlAppPv', String(pv));
    if (pv >= 2) { setTimeout(showCard, 5000); return; }
    var scrolled = false, t0 = Date.now();
    function onScroll() { if (window.scrollY > 500) { scrolled = true; window.removeEventListener('scroll', onScroll); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(function check() {
      if (scrolled) showCard(); else if (Date.now() - t0 < 120000) setTimeout(check, 5000);
    }, 25000);
  }

  /* ---------- rehber ---------- */
  var sheet = root.querySelector('.lwl-ai-sheet');
  var lastFocus = null;
  function guide() {
    var steps = [], note = '', title = 'LWL\'yi ana ekranına ekle', lead = 'Uygulama gibi tek dokunuşla açılır. Kampanyalar ve Kombin Atölyesi hep elinin altında.', copy = false, hint = false;
    if (inApp) {
      var app = /Instagram/i.test(ua) ? 'Instagram' : (/FBAN|FBAV|FB_IAB|FBIOS/i.test(ua) ? 'Facebook' : (/musical_ly|Bytedance|TikTok/i.test(ua) ? 'TikTok' : 'Bu uygulama'));
      var br = isIOS ? 'Safari' : 'Chrome';
      title = 'Önce ' + br + '\'de aç';
      lead = app + ' içinden ana ekrana eklenemiyor. Sayfayı ' + br + '\'de açınca tek adımda ekleyebilirsin.';
      steps = [
        'Sağ üstteki ' + k(isIOS ? 'more' : 'kebab') + ' menüsüne dokun.',
        '<b>' + (isIOS ? '"Tarayıcıda aç" / "Safari\'de aç"' : '"Tarayıcıda aç" / "Chrome\'da aç"') + '</b> seçeneğini seç.',
        'Açılan sayfada <b>LWL\'yi ana ekranına ekle</b> butonuna tekrar dokun.'
      ];
      note = 'Menüde bu seçenek yoksa bağlantıyı kopyalayıp ' + br + '\'ye yapıştırabilirsin.';
      copy = true;
    } else if (isIOS) {
      var ver = parseInt((ua.match(/Version\/(\d+)/) || [])[1], 10) || 0;
      var other = /CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
      var first;
      if (other) first = 'Adres çubuğundaki ' + k('share', true) + ' <b>Paylaş</b> simgesine dokun.';
      else if (isIPad) first = 'Üst çubuktaki ' + k('share', true) + ' <b>Paylaş</b> simgesine dokun.';
      else if (ver >= 26) { first = 'Alttaki ' + k('more', true) + ' simgesine, ardından ' + k('share', true) + ' <b>Paylaş</b>\'a dokun.'; hint = true; }
      else { first = 'Alttaki çubukta ' + k('share', true) + ' <b>Paylaş</b> simgesine dokun.'; hint = true; }
      steps = [
        first,
        'Listeyi biraz kaydır ve ' + k('plus') + ' <b>Ana Ekrana Ekle</b>\'ye dokun.',
        'Sağ üstte <b>Ekle</b>\'ye dokun. LWL ikonu ana ekranında!'
      ];
      note = '"Ana Ekrana Ekle" görünmüyorsa sayfayı Safari\'de açıp tekrar dene.';
    } else {
      if (/SamsungBrowser/i.test(ua)) {
        steps = [
          'Alttaki ' + k('menu') + ' menüsüne dokun.',
          '<b>Sayfayı ekle</b> &rarr; <b>Ana ekran</b>\'ı seç.',
          '<b>Ekle</b>\'ye dokun. LWL ikonu ana ekranında!'
        ];
      } else {
        steps = [
          'Sağ üstteki ' + k('kebab') + ' menüsüne dokun.',
          '<b>Uygulamayı yükle</b> ya da <b>Ana ekrana ekle</b>\'yi seç.',
          '<b>Yükle</b> / <b>Ekle</b>\'ye dokun. LWL ikonu ana ekranında!'
        ];
      }
    }
    root.querySelector('.js-ai-title').textContent = title;
    root.querySelector('.js-ai-lead').textContent = lead;
    root.querySelector('.js-ai-steps').innerHTML = steps.map(function (s) { return '<li>' + s + '</li>'; }).join('');
    var n = root.querySelector('.js-ai-note'); n.textContent = note; n.hidden = !note;
    root.querySelector('.js-ai-copy').hidden = !copy;
    root.querySelector('.js-ai-hint').hidden = !hint;
  }
  function openSheet() {
    guide();
    lastFocus = document.activeElement;
    hideCard();
    sheet.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('is-in'); }); });
    setTimeout(function () { var x = sheet.querySelector('.lwl-ai-sheet__x'); x && x.focus({ preventScroll: true }); }, 60);
  }
  function closeSheet() {
    if (sheet.hidden) return;
    set({ guided: Date.now() });
    sheet.classList.remove('is-in');
    document.documentElement.style.overflow = '';
    setTimeout(function () { sheet.hidden = true; }, 400);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  sheet.addEventListener('click', function (e) { if (e.target.closest('[data-lwl-ai-close]')) closeSheet(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  root.querySelector('.js-ai-copy').addEventListener('click', function () {
    var url = location.origin + location.pathname + location.search;
    var done = function () { toast('Bağlantı kopyalandı'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { fallbackCopy(url); done(); });
    else { fallbackCopy(url); done(); }
  });
  function fallbackCopy(t) {
    var a = document.createElement('textarea'); a.value = t; a.setAttribute('readonly', ''); a.style.cssText = 'position:fixed;top:-100px;opacity:0';
    document.body.appendChild(a); a.select(); try { document.execCommand('copy'); } catch (e) {} a.remove();
  }

  /* ---------- yükleme ---------- */
  function install() {
    if (deferred && !inApp) {
      var d = deferred; deferred = null; hideCard();
      d.prompt();
      d.userChoice.then(function (c) {
        if (c && c.outcome === 'accepted') { set({ installed: Date.now() }); hideAll(); toast('LWL ana ekranına eklendi'); }
        else { var s = get(); set({ dismissed: Date.now(), dn: (s.dn || 0) + 1 }); }
      }, function () {});
      return;
    }
    openSheet();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-lwl-install]');
    if (!t) return;
    e.preventDefault();
    install();
  });
  window.lwlInstall = install;

  function hideAll() {
    hideCard();
    [].forEach.call(document.querySelectorAll('.lwl-ai-ft, .lwl-ai-pill'), function (el) { el.remove(); });
  }
  var toastTimer = null;
  function toast(msg) {
    var t = root.querySelector('.lwl-ai-toast');
    t.textContent = msg; t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.hidden = true; }, 300); }, 2600);
  }

  function start() { addFooterButton(); addAtolyeButton(); scheduleCard(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();